@let pallet = palletInput();
<div class="flex items-center gap-2 w-full px-2 py-2 ">
  <div class="flex flex-col gap-1 w-full">
    <span class="soft-overline">{{pallet.sscc}}</span>
    <div class="flex flex-row justify-between w-full">
      <div class="flex flex-row gap-1 justify-center items-center">
        <span>{{number()}}. Palette</span>
      </div>
      <span>{{pallet.menge | number:'1.1-7'}} {{pallet.einheit.arteh}}</span>
    </div>

    @if (pallet?.lagerplatz && (pallet?.lagerplatz?.lagerplatz | isDefinedNotEmpty)) {
      <div class="italic text-sm text-light">Lagerplatz: {{ pallet?.lagerplatz?.lagerplatz }}</div>
    }
  </div>
</div>
